"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthedMutationWithAccountId = exports.useAuthedLazyQuery = void 0;
const client_1 = require("@apollo/client");
const LocalAccount_1 = __importDefault(require("./LocalAccount"));
const renderWithLoadingAndErrorHandling_1 = __importDefault(require("./renderWithLoadingAndErrorHandling"));
// This interogates the actual GraphQL query/mutation definition
// and returns a boolean indicating whether or not `accountId`
// is part of the query.
function requiresAccountId(gql) {
    const definitions = gql.definitions;
    let shouldInjectAccountId = false;
    definitions.forEach((definition) => {
        definition.variableDefinitions.forEach((varDef) => {
            if (varDef.variable.name.value === 'accountId') {
                shouldInjectAccountId = true;
            }
        });
    });
    return shouldInjectAccountId;
}
// Automatically injects the accountId if it is defined in the
// query. This prevents developers from having to keep an up-to-date
// reference to the current accountId (which is tricky with lots of
// nested components).
function useAuthedLazyQuery(gql, opts = {}) {
    const [getQuery, args] = (0, client_1.useLazyQuery)(gql, opts);
    const injectAccountId = (graphqlVars = {}) => {
        const accountId = LocalAccount_1.default.getId();
        const updatedGraphqlVars = {
            variables: Object.assign(Object.assign({}, graphqlVars.variables), { accountId: accountId ? accountId : 0 })
        };
        return getQuery(updatedGraphqlVars);
    };
    const curriedRenderWithLoadingAndErrorHandling = (argOverrides) => {
        return (0, renderWithLoadingAndErrorHandling_1.default)(Object.assign(Object.assign({}, args), argOverrides));
    };
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'renderWithLoadingAndErrorHandling' does ... Remove this comment to see the full error message
    args.renderWithLoadingAndErrorHandling =
        curriedRenderWithLoadingAndErrorHandling;
    if (requiresAccountId(gql)) {
        return [injectAccountId, args];
    }
    return [getQuery, args];
}
exports.useAuthedLazyQuery = useAuthedLazyQuery;
function useAuthedMutationWithAccountId(gql, opts = {}) {
    const [mutation, args] = (0, client_1.useMutation)(gql, opts);
    const injectAccountId = (graphqlVars = {}) => {
        const accountId = LocalAccount_1.default.getId();
        const updatedGraphqlVars = {
            variables: {
                input: Object.assign(Object.assign({}, graphqlVars), { accountId: accountId ? accountId : 0 })
            }
        };
        return mutation(updatedGraphqlVars);
    };
    return [injectAccountId, args];
}
exports.useAuthedMutationWithAccountId = useAuthedMutationWithAccountId;
